import React from 'react';

import AdminCardField from '../admin-card-fields/AdminCardField/AdminCardField';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminRateCard.css';

export default function AdminRateCard({
  service,
  rate,
  onEditClickHandler,
  onDeleteClickHandler,
}) {
  return (
    <div className='admin-prices-item-card'>
      <div className='admin-rate-component-info'>
        <div className='admin-rate-title-container'>
          <AdminCardField label='Rate Title:' type='text'>
            {rate.name}
          </AdminCardField>
        </div>
        <div className='admin-rate-price-hst-container'>
          <div className='admin-rate-price-container'>
            <AdminCardField label='Rate:' type='currency'>
              {rate.price || 0}
            </AdminCardField>
          </div>
          <div className='admin-rate-hst-container'>
            <AdminCardField label='+HST:' type='checkbox'>
              {rate.is_hst}
            </AdminCardField>
          </div>
        </div>
      </div>
      <div className='admin-prices-buttons'>
        <ContentChangeButton
          iconType='edit'
          onClickHandler={() => onEditClickHandler(service, rate)}
        />
        <ContentChangeButton
          iconType='delete'
          onClickHandler={() => onDeleteClickHandler(service, rate)}
        />
      </div>
    </div>
  );
}
